import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * Dates can be inputed in the format: DD/MM/YYYY.
 * And the week is set to start on monday.
 */
@Injectable()
export class FranceDateAdapter extends NativeDateAdapter {

    parse(value: unknown): Date | null {
        if ((typeof value === 'string') && (value.indexOf('/') !== -1)) {
            const [date, month, year] = value.split('/');
            const valid = (num: string | undefined) => num !== undefined && num.length > 0;

            if (!(valid(date) && valid(month) && valid(year) && year.length > 3)) {
                return null;
            }

            return new Date(Number(year), Number(month) - 1, Number(date));
        }

        return null;
    }

    getFirstDayOfWeek(): number {
        return 1;
    }
}
